import AppointmentPatientFilter from "./AppointmentPatientFilter";
export default AppointmentPatientFilter;
